import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { SettingDisplay } from 'lib/SettingDisplay';
import { isString } from 'lib/typeguards';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface SettingDisplayPasswordProps {
    title?: string;
    text?: React.ReactNode;
    description?: string;
    crop?: boolean;
    buildtimeIOS?: boolean;
    buildtimeAndroid?: boolean;
    variant?: 'body2' | 'body1';
}

export const SettingDisplayPassword: React.FC<SettingDisplayPasswordProps> = ({
    text,
    title,
    description,
    crop,
    buildtimeIOS,
    buildtimeAndroid,
    variant = 'body2'
}) => {
    const [isVisible, setIsVisible] = React.useState(false);
    const toggleVisibility = React.useCallback(() => {
        setIsVisible(!isVisible);
    }, [isVisible]);
    const displayValue = React.useMemo(() => {
        const value = isVisible ? text : '•'.repeat(isString(text) ? text.length : 0);
        if (crop && isString(value) && value.length > 50) {
            return `${value.substring(0, 50)}...`;
        }
        return value;
    }, [crop, isVisible, text]);
    return (
        <SettingDisplay
            label={title}
            description={description}
            buildtimeIOS={buildtimeIOS}
            buildtimeAndroid={buildtimeAndroid}
        >
            <Box display="flex" alignItems="center" width="100%">
                <Typography
                    variant={variant}
                    sx={{ wordBreak: 'break-word', flex: 1, minWidth: 0 }}
                    noWrap={!!crop}
                >
                    {displayValue}
                </Typography>
                <IconButton onClick={toggleVisibility} sx={{ ml: 1 }}>
                    {isVisible ? <VisibilityOff /> : <Visibility />}
                </IconButton>
            </Box>
        </SettingDisplay>
    );
};
